import actions from './actions'

const initialState = {
  loading: false,
  error: false,
  customerTags: [],
  audience: {
    loading: false,
  },
}

export default function customerTagsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_AUDIENCE_STATE:
      return { ...state, audience: { ...state.audience, ...action.payload } }
    default:
      return state
  }
}
